import { Box, CircularProgress, Icon, Skeleton, Typography } from '@mui/material'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import BottomAddToCart from './BottomAddToCart'
import WorkExperienceCard from './WorkExperienceCard'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const WorkingExperienceDrawer = ({ data, error, isLoading, unlocked }) => {
  if (isLoading) {
    return (
      <Box paddingX={2}>
        <Typography
          variant="h4"
          color="dark-text.main"
          paddingY={1}
          align="left"
          marginBottom={2}
          sx={{
            fontWeight: 'bold',
            textTransform: 'capitalize',
          }}
        >
          <Skeleton variant="text" width={'40%'} />
        </Typography>
        <Box display="flex" gap={9}>
          <Typography
            width={80}
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" />
          </Typography>
          <Typography
            display="flex"
            alignItems="center"
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" width={100} />
          </Typography>
        </Box>
        <Box display="flex" gap={9}>
          <Typography
            width={80}
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" />
          </Typography>
          <Typography variant="body1" color="dark-text.main" align="left" marginBottom={2}>
            <Skeleton variant="text" width={100} />
          </Typography>
        </Box>

        <Box display="flex" flexDirection="column">
          <Typography variant="body1" color="light-gray-text.main" align="left">
            <Skeleton variant="text" width={'40%'} />
          </Typography>
          <Typography
            variant="body1"
            color="dark-text.main"
            align="left"
            marginBottom={2}
            textAlign="justify"
            maxWidth="95%"
          >
            <Skeleton variant="rounded" width={'100%'} height={100} />
          </Typography>
        </Box>
      </Box>
    )
  } else if (error !== null || data === null || data.length <= 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: 200,
          overflow: 'hidden',
        }}
      >
        <AdxEmptyStateV2
          icon={<Icon>business_center</Icon>}
          title="No work experience found"
          subtitle={null}
        />
      </Box>
    )
  } else {
    return (
      <>
        {data?.map((list, index) => (
          <WorkExperienceCard
            key={index}
            unlocked={unlocked}
            position={list.position}
            startMonth={list.start_month}
            startYear={list.start_year}
            endMonth={list.end_month}
            endYear={list.end_year}
            jobDesc={list.job_description}
            current={list.current_job}
            salary={list.salary}
            company={list.company_name}
          />
        ))}
      </>
    )
  }
}
export default WorkingExperienceDrawer
